<div class="container">

    <p class="txt_nome_escola">{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>

    <div *ngIf="isLoading" class="loading">
        <mat-spinner></mat-spinner>
    </div>

    <mat-card class="card" *ngIf="!isLoading">
        <mat-card-content>

            <table mat-table class="table" [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="nome_dependente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                    <td mat-cell *matCellDef="let row">{{ row.nome_dependente }}</td>
                    <td mat-footer-cell *matFooterCellDef> Total</td>
                </ng-container>
                <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Valor
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.total | currency:'BRL':'symbol':'1.2-2'}}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ total | currency:'BRL':'symbol':'1.2-2'}}
                        <!-- Exibe o valor do dependente atual -->
                        <!-- {{ totalPorDependente[serie.nome_dependente] | currency:'BRL':'symbol':'1.2-2' }} -->
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>

            <label id="radio-group-label">Forma de entrega: </label>
            <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="formaSelecionada">
                <mat-radio-button class="radio-button" *ngFor="let forma of forma_entrega" [value]="forma.id_forma">
                    {{forma.descricao}}
                </mat-radio-button>
            </mat-radio-group>

        </mat-card-content>

        <mat-card-actions align="start">
            <button mat-raised-button color="primary" (click)="continuar()">CONTINUAR</button>
            <button mat-button type="button" [routerLink]="'/lista-material'">VOLTAR</button>
        </mat-card-actions>
    </mat-card>
</div>